import { Link } from 'react-router-dom';

interface IntroSectionProps {
  dramaCount: number;
  specialCount: number;
}

const highlights = [
  { icon: 'ri-file-text-line', title: '完整剧情介绍', desc: '每部剧集都配有剧情简介与深度解析，帮助快速了解主线与看点。' },
  { icon: 'ri-filter-3-line', title: '多维筛选浏览', desc: '按地区、更新时间与评分区间筛选，配合排序快速定位心仪作品。' },
  { icon: 'ri-heart-3-line', title: '收藏与相关推荐', desc: '一键收藏感兴趣的作品，并在详情页发现同类型的高质量剧集。' },
];

export default function IntroSection({ dramaCount, specialCount }: IntroSectionProps) {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10">
            <span className="mb-3 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-accent-600">
              <span className="h-3 w-0.5 rounded-full bg-accent-500" />
              关于本站
            </span>
            <h2 className="font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              读懂韩国伦理剧，从剧情到人心
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              韩国伦理剧专题是一个聚焦家庭、婚姻与亲情题材的影视内容平台。我们用结构化的剧集资料、专题策展与剧情解析，帮助观众在众多作品中快速找到值得一看的故事，也读懂那些藏在日常对白里的情感与选择。
            </p>

            <div className="mt-6 flex flex-wrap gap-6">
              <div>
                <p className="font-heading text-3xl font-bold text-primary-600">{dramaCount}</p>
                <p className="mt-1 text-xs text-foreground-500">收录剧集</p>
              </div>
              <div className="h-12 w-px bg-background-300" />
              <div>
                <p className="font-heading text-3xl font-bold text-accent-600">{specialCount}</p>
                <p className="mt-1 text-xs text-foreground-500">精选专题</p>
              </div>
              <div className="h-12 w-px bg-background-300" />
              <div>
                <p className="font-heading text-3xl font-bold text-secondary-600">每日</p>
                <p className="mt-1 text-xs text-foreground-500">内容更新</p>
              </div>
            </div>

            <div className="mt-7 flex flex-wrap gap-3">
              <Link
                to="/category/ethical-drama"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
              >
                开始浏览剧集
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-200"
              >
                了解我们
              </Link>
            </div>
          </div>

          <div className="flex flex-col justify-center gap-3 border-t border-background-200 bg-background-50 p-6 md:gap-4 md:border-l md:border-t-0 md:p-10">
            {highlights.map((h) => (
              <div key={h.title} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className={`${h.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950">{h.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{h.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}